import { IconPack } from "SuperAdmin/Config/Icon";
import { ImageCheckType, ImageType } from "SuperAdmin/Config/ImageType";
import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { ImageCheck } from "..";
import useDebounce from "../UseDebounce/useDebounce";
import styles from "./SelectComponents.module.scss";
import { useLocation } from "react-router-dom";

const SelectInstitution = ({
  placeholder,
  functionSearch,
  form,
  mappedProfile,
  disabled,
}) => {
  const pathname = useLocation().pathname.split("/")[2];
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);
  const [isLoading, setIsLoading] = useState(false);
  const [chosenData, setChosenData] = useState();
  useEffect(() => {
    setChosenData(mappedProfile);
  }, [mappedProfile]);
  const renderItem = (value) => {
    const data = value.data;
    return (
      <div
        className={styles["management-scope-item"]}
        onClick={() => handleSelectScope(data)}
      >
        <div className={styles["management-scope"]}>
          <ImageCheck
            url={`https://media.academic.online/institutions_images/${data.id}/${ImageType.THUMBNAIL}.png`}
            classname={styles["photo"]}
            alt={"avatar"}
            type={ImageCheckType.INSTITUTION_LOGO}
          />
        </div>
        <div className={styles["management-scope-info"]}>
          <p className={styles["management-scope-name"]}>{data?.name}</p>
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (debouncedValue) {
      setIsLoading(true);
      setOptions([]);
      functionSearch({ query: debouncedValue }, (res) => {
        setOptions(res.results);
        setIsLoading(false);
      });
    }
  }, [debouncedValue]);
  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleSelectScope = (value) => {
    setChosenData(value);
    form.setFieldsValue({
      institution_id: value.id,
      institution_name: value.name,
      management_scope_id: value.id,
      management_scope_name: value.name,
    });
  };
  console.log(chosenData);
  const handleDeleteChosenManagementScope = () => {
    setChosenData(null);
    form.setFieldsValue({
      institution_id: null,
      institution_name: null,
      management_scope_id: null,
      management_scope_name: null,
    });
  };
  return (
    <div className={styles["select-management-scope"]}>
      <Select
        showSearch
        placeholder={placeholder}
        filterOption={false}
        onSearch={handleInputChange}
        notFoundContent={isLoading ? <Spin size="small" /> : null}
        options={options}
        optionRender={(option) => renderItem(option)}
        searchValue={query}
        disabled={disabled}
      />
      {chosenData && (
        <div className={styles["chosen-scope"]}>
          <div className={styles["management-scope-chosen"]}>
            <div className={styles["management-scope"]}>
              <ImageCheck
                url={`https://media.academic.online/institutions_images/${chosenData.id}/${ImageType.THUMBNAIL}.png`}
                classname={styles["photo"]}
                alt={"avatar"}
                type={ImageCheckType.INSTITUTION_LOGO}
              />
            </div>
            <div className={styles["management-scope-info"]}>
              <p className={styles["management-scope-name"]}>
                {chosenData?.name}
              </p>
            </div>
          </div>
          {pathname !== "create-account" && (
            <div
              className={styles["delete-chosen-profile"]}
              onClick={handleDeleteChosenManagementScope}
            >
              {IconPack.close_icon}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectInstitution;
